<template>
	<div>
		<HeadIndex :info="true"></HeadIndex>
		<el-row>
			<el-col :span="6" :offset="4" class="logo_m">
				<!--<div class="logo_m_img">
					<img src="../../assets/img/1.png" alt="">
				</div> -->
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="loginindex">
					<el-row>
						<el-col :span="6" :offset="17">
							<div class="login-form">
								<div>
									<div class="title" @click="activeName=(activeName=='1')?2:1">登 录</div>
								</div>
								<div style="display: flex;justify-content: center;">
									<div v-if="activeName=='1'" style="width: 73%;">
											<el-form :model="formData" ref="formData" :rules="rules">
												<div class="input">
													<el-input v-model="formData.mobile" style="height: 40px;" placeholder="请输入您的手机号码">
														<template #prefix>
															<el-icon class="el-input__icon">
																<search />
															</el-icon>
														</template>
													</el-input>
												</div>
												<div class="input">
													<el-input v-model="formData.password" type="password" style="height: 40px;" placeholder="请输入密码">
														<template #prefix>
															<el-icon class="el-input__icon">
																<search />
															</el-icon>
														</template>
													</el-input>
												</div>
											</el-form>
										</div>
										<div v-if="activeName=='2'" class="login-form-helper" style="width: 73%;">
											<el-form :model="formData" ref="formData" :rules="rules">
												<div class="input">
													<el-input v-model="formData.user_mobile" style="height: 40px;" placeholder="请输入主账号">
														<template #prefix>
															<el-icon class="el-input__icon">
																<search />
															</el-icon>
														</template>
													</el-input>
												</div>
												<div class="input">
													<el-input v-model="formData.mobile" style="height: 40px;" placeholder="请输入您的手机号码">
														<template #prefix>
															<el-icon class="el-input__icon">
																<search />
															</el-icon>
														</template>
													</el-input>
												</div>
												<div class="input">
													<el-input v-model="formData.password" type="password" style="height: 40px;" placeholder="请输入密码">
														<template #prefix>
															<el-icon class="el-input__icon">
																<search />
															</el-icon>
														</template>
													</el-input>
												</div>
											</el-form>
										</div>
									<!-- <el-tabs v-model="activeName" type="card" class="demo-tabs" @tab-click="handleClick">
									<el-tab-pane label="账号登录" name="1">
										
									</el-tab-pane>
									<el-tab-pane label="帮手登录" name="2">
										
									</el-tab-pane>
																	</el-tabs> -->
								</div>
								<!-- <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input3">
								</el-input> -->
								<div class="input">
									<el-button style="width:70%;height: 40px;background: #ff8a5c;color:#fff" round @click="login" :loading="loading" >登 录</el-button>
								</div>
								<div style="margin-top:5px;text-align:center;font-size:12px">
									<span>
								
										<el-checkbox v-model="checked1" label="Option 1" size="large" >
											<template #default>
												<span>
													我已阅读并同意
												</span>
												<span style="color:red">
													<el-link type="danger" underline="hover" @click.stop.prevent="agreementUser('/agreementUser')" >《用户协议》</el-link>
												</span>
												<span>|</span>
												<span style="color:red">
													<el-link type="danger" underline="hover" @click.stop.prevent="agreementUser('/agreementPrivacy')" >《隐私政策》</el-link>
												</span>
											</template>
										</el-checkbox>
									</span>
									
								</div>
								<div class="input bottom">
									<el-row>
										<el-col :span="12">
											<el-link type="primary" @click="$router.push('/forgetPassword')">忘记密码</el-link>
										</el-col>
										<el-col :span="12" style="color: #ff8a5c;">
											<el-link type="primary" @click="$router.push('/register')">去注册</el-link>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import '../../assets/login/index.css' //优化表格样式
import { ElMessage } from 'element-plus'
import HeadIndex from '../public/HeadIndex';
export default {
	name: 'LoginIndex',
	components: {
		HeadIndex,
	},
	data() {

		return {
			checked1:false,
			activeName: '1',
			loading: false,
			formData: {
				password: '',
				mobile: '',
				user_mobile: '',
			},
		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {
		agreementUser(url){
			const newUrl = this.$router.resolve({ path: url}).href;
			window.open(newUrl, '_blank');
		},
		openUserAgreement(){

		},
		handleClick() {
			this.formData= {
				password: '',
				mobile: '',
				user_mobile: '',
			};
		},
		async bind() {
			await this.$axios.post('/api/yunsys.Chatroom/bind', { client_id: localStorage.getItem('client_id') }).then(async (res) => {
					var res = res.data;

				})
				.catch(err => {

				})
		},
		async login() {
			if (!this.checked1) {
				return ElMessage({
						message: '请阅读并同意《用户协议》《隐私政策》！',
						type: 'error',
						grouping: true // 开启合并功能
					})
			}
			//手动验证
			if (this.activeName==2) {
				if (!this.$validator.phone(this.formData.user_mobile)) {
					return ElMessage({
						message: '请填写正确的主账号！',
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
			}
			if (!this.$validator.phone(this.formData.mobile)) {
				return ElMessage({
					message: '请填写正确的手机号！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			if (!this.formData.password) {
				return ElMessage({
					message: '请填写密码！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			this.loading = true
			this.formData.type=this.activeName;
			await this.$axios.post('/api/yunsys.Website/login', this.formData).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					//登录成功 储存令牌
					localStorage.setItem('token', res.data.token)
					localStorage.setItem('mobile', res.data.mobile)
					localStorage.setItem('user_id', res.data.id)
					localStorage.setItem('lead_id', res.data.lead_id)
					localStorage.setItem('username', res.data.username)
					localStorage.setItem('code', res.data.code)
					this.bind()
					var obj = this;
					return ElMessage({
						message: res.msg,
						type: 'success',
						duration: 1000,
						grouping: true, // 开启合并功能
						onClose: function(v) {
							obj.$router.push({ path: '/' });
						}
					})
				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		}
	}
}
</script>
<style lang="less" scoped>
.demo-tabs > .el-tabs__header {
  display: flex;
  justify-content: center;
}

/* 如果需要调整卡片式标签的样式 */
.demo-tabs > .el-tabs__header .el-tabs__nav {
  border: none;
}
.demo-tabs > .el-tabs__header .el-tabs__item {
  border: 1px solid #dcdfe6;
  margin: 0 4px;
  border-radius: 4px 4px 0 0;
}
:deep(.el-tabs){
	width: 73%;
	margin-top: 5px;
}
:deep(.el-tabs__nav){
	width: 100%
}
:deep(.el-tabs__item) {
	width: 50%
}
:deep(.el-tabs--card > .el-tabs__header .el-tabs__item.is-active){
	border-bottom: 1px solid transparent;
}
:deep(.el-link__inner) {
  font-size: 13px;
}
</style>